import { fetchData } from './fetchData';

export type RepairDraftRequestData = {
    login: string,
    line_uid: string,
    // 服務據點
    location_bef: '',
    // 產品識別碼
    barcode_bef: string,
    // 產品序號
    sn_code_id_bef: string,
    // 產品型號
    product_model_id_bef: string,
    // 問題分類
    reason_ids_bef: string,
    // 問題簡述
    reason_bef: string,
    // 檔案
    extra_file: string,
    // 公司/學校系所
    partner_user_id_bef: string,
    // 公司/學校統編
    customer_vat_bef: string,
    // 部門單位/老師實驗室
    customer_department_id_bef: string,
    // 主要聯絡人
    customer_main_contact_id_bef: string,
    // 取件地點
    address_bef: string,
    // 取件聯絡人
    contact_id_bef: string,
    // 取件聯繫電話/手機
    contact_phone_bef: string,
    // 取件聯繫E-mail
    contact_email_bef: string,
    // 希望收件日期
    repair_date_wish_bef: string | false,
};

type RepairDraftResponseData = {
    status: string,
    msg: string,
    // 報修單號
    name: string,
};

function repairDraft(data: RepairDraftRequestData): Promise<RepairDraftResponseData> {
    return fetchData('api/repair_draft', {
        method: 'POST',
        body: JSON.stringify({
            ...data,
            reason_ids_bef: `[[6,False,[${data.reason_ids_bef}]]]`,
        }),
    })
        .then((res) => res.json())
        .then((resData: RepairDraftResponseData) => resData);
}

export { repairDraft };
